export default {
  v2: {
    change: 'Promenite ',
    remove: 'Uklonite',
    auto_background: 'Automatska pozadina',
    create_new_course_org: 'Kreirajte novi kurs za Vašu organizaciju.',
    create_new_course_marketplace: ' Kreirajte novi kurs za tržište.',
    create_new_course_both:
      'Kreirajte novi kurs za Vašu organizaciju i za tržište.',
    ok: 'U redu',
    page_bg: 'Pozadina stranice',
    lesson_cover: ' Naslovna slika lekcija',
    create_skill_journey: ' Kreirajte obilazak veština',
    add_to_basket: ' Dodajte u korpu',
    basket: 'KORPA ',
    times: 'Puta',
    mazes: 'Lavirinti',
    events: 'Događaji',
    scroms: 'Scorm-ovi',
    min_score_pass: 'Minimalna ocena za prolaz',
    no_scorms_available: ' Nema dostupnih scorm-ova.',
    no_events_available: ' Nema dostupnih događaja.',
    no_courses_available: ' Nema dostupnih kurseva.',
    no_courses_baskets: 'Nema kurseva u korpi.',
    no_mazes_baskets: 'Nema lavirinata u korpi.',
    no_scroms_baskets: 'Nema scorm-ova u korpi.',
    no_events_baskets: ' Nema događaja u korpi.',
    option_1: 'Opcija 1',
    option_2: 'Opcija 2',
    enter_number_words: 'Unesite broj reči',
    summarize: ' Rezimirajte',
    answer: ' Odgovorite',
    hold_tight_one_minute:
      ' Sačekajte, još uvek se pripremamo. Može da potraje i do jednog minuta.',
    enter_question: ' Unesite pitanje',
    enter_relevant_documents: ' Unesite broj relevantnih dokumenata',
    please_input_relevant_documents: 'Unesite relevantan broj dokumenata!',
    please_wait_loading_results: 'Rezultati se učitavaju, molimo sačekajte…',
    proceed_to_add_voice: 'Nastavite da dodate glas',
    results: 'Rezultati',
    no_result_found_try_asking_questions:
      'Nema pronađenih rezultata, pokušajte da postavite još pitanja',
    eg: 'npr',
    what_make_sales_manager: 'Šta me može učiniti menadžerom prodaje',
    please_select_lang: 'Izaberite bilo koji jezik!',
    search: 'Pretraga',
    please_copy_desired_content:
      ' Kopirajte željeni sadržaj iz levog polja u desno polje.',
    rating_req: ' Ocena je obavezna.',
    review_req: ' Recenzija je obavezna.',
    rating_review_req: 'Ocena i recenzija moraju da se navedu.',
    how_rate_this: 'Kako biste ovo ocenili',
    amazing_above_expectations: 'Odlično, iznad očekivanja!',
    certificates: 'Sertifikati',
    you_no_certificates: ' Trenutno nema dostupnih sertifikata.',
    please_add_review: 'Molimo Vas da ostavite recenziju za ocenu, hvala.',
    post: 'Postavite',
    rate: 'Ocenite',
    avg_rating: 'Prosečna ocena',
    no_review_found: 'Nema recenzija',
    are_sure_to_disale_zoom_integration:
      'Da li ste sigurni da želite da onemogućite integraciju zumiranja?',
    badges: 'Bedzevi',
    you_no_badge_available: 'Trenutno nema dostupnih bedzeva.',
    download_certificate: 'Preuzmite sertifikat',
    loading: 'Učitavanje...',
    no_file_attached: 'Nema priloženih datoteka',
    sorry: 'Izvinite!',
    you_do_not_have_any_notes: 'Nemate beleške.',
    question: 'Pitanje',
    score: 'Rezultat',
    alert_score_message: 'Osoba je/su prosledili svoje rezultate.',
    alert_question_message: 'Do sada nije dodato ni jedno pitanje.',
    button_submit: 'Prosledite',
    button_allScores: 'Svi rezultati su prosleđeni.',
    record_wait: 'Snimanje počinje. Molimo sačekajte...',
    buttonSubmit_warning: 'Unesite sve rezultate pre prosleđivanja',

    // List.jsx @Added:Mahesh
    upload_ar_assets: 'Otpremite AR sredstva',
    edit_ar_assets: 'Uredite AR sredstva',
    upload_assets: 'Otpremite sredstva',

    // ARUploads.jsx @Added:Mahesh
    trigger_title: 'Naslov okidača',
    trigger_description: 'Opis okidača',
    please_type_target_description: 'Upišite opis cilja',
    trigger_image: 'Slika okidača*',
    upload_trigger_image: 'Otpremite sliku okidača',
    drag_n_drop: 'Prevucite i ispustite',
    file_size_should_not_exceed:
      '(Veličina datoteke ne bi trebalo da prelazi 2 MB)',
    ar_content: 'AR Sadržaj *',
    upload_3d_zip: 'Otpremite 3D Zip',
    content_attached: 'Sadržaj priložen.',
    enter_trigger_image_title: 'Unesite naslov slike okidača',
    ar_preview_image: 'AR Pregled slike',
    upload_preview_image: 'Otpremite sliku za pregled',
    creating___: 'Kreiranje...',
    updating___: 'Ažuriranje...',
    create: 'Kreirajte',
    update: 'Ažurirajte',
    ar_assets: 'AR Slika',
    _3d_files_mp4: '(Zipped .OBJ, .FBX)',
    persons_have_submitted_their_scores:
      ' Osoba je/su prosledili svoje rezultate.',
    no_questions_added_till_now: ' Do sada nije dodato ni jedno pitanje.',
    submit: 'Prosledite',
    all_scores_submitted: 'Svi rezultati su prosleđeni.',
    recording_is_starting: ' Snimanje počinje. Molimo sačekajte…',
    please_input_scores_before_submitting:
      'Unesite sve rezultate pre prosleđivanja',
    //EventMenus.jsx
    end_for_all: ' Završite za sve',
    full_screen: 'Ceo ekran',
    breakout_room: 'Soba za odmor',
    //ChimeConference.jsx
    send_invitations: ' Pošaljite pozivnicu (e)',
    add_participants: 'Dodajte učesnika (e)',
    create_breakout_room: 'Kreirajte sobu za odmor',
    //AntMediServeice.jsx
    connecting: 'Povezivanje...',
    //AntPlayer.jsx
    currently_broadcaster_unavailable: 'Emiter trenutno nije dostupan.',
    //BreakoutForm.jsx
    how_many_breakout_room_to_create: 'Koliko soba za odmor da se napravi?',
    create_upto_three_breakout_rooms: '*Kreirajte do 3 sobe za odmor',
    //PassiveUsers/index.js
    allow: 'Dozvolite',
    //PreviewHeader.jsx
    additional: 'Dodatni',
    attachment: 'Prilozi',
    //EventOverview.jsx
    no_description_available: 'Opis nije dostupan.',
    //EventParticipants.jsx
    people: 'LJUDI',
    waiting: 'Čekanje',
    hand_raising_users: 'Korisnici koji podižu ruku -',
    invite: 'pozovite',
    //EventRooms.jsx
    create_room: 'Napravite sobu',
    //Header.jsx
    create_live_event: 'Napravite događaj uživo',
    //Detail.jsx
    support_upto_fivethousand_participants:
      ' Podržava do 5000 učesnika na događaju',
    support_upto_ten_participants:
      ' Podržava do 10 učesnika video zapisa uživo',
    support_upto_twohundred_participants:
      ' Podržava do 200 učesnika na događaju',
    supprt_upto_five_participants: 'Podržava do 5 učesnika video zapisa uživo',
    support_upto_twentyfive_participants:
      'Podržava do 25 učesnika video zapisa uživo na događaju',
    two_live_video_participants:
      '2 učesnika video zapisa uživo za događaj (domaćin i učesnik)',
    you_can_have_upto_five_examinees: 'Možete da imate do 5 ispitanika.',
    you_can_have_upto_twentyfive_participants:
      'Možete da imate do 25 učesnika.',
    you_can_have_upto_five_participants: 'Možete da imate do 5 učesnika.',
    you_can_have_upto_ten_participants: 'Možete da imate do 10 učesnika.',
    select_hosts_email: 'Izaberite e-poštu domaćina',
    //Setting.jsx
    send_invite_email: 'Pošaljite e-poruku sa pozivnicom',
    do_not_send_invite_email: 'Nemojte da šaljete e-poruku sa pozivnicom',
    error: 'Greška',
    //ShowContactsModal.jsx
    max_twentyfive_users_allowed:
      'Dozvoljeno je da izaberete najviše 25 korisnika',
    max_five_users_allowed: 'Dozvoljeno je da izaberete najviše 5 korisnika',
    max_ten_users_allowed: 'Dozvoljeno je da izaberete najviše 10 korisnika',
    no_user_found: 'Nijedan korisnik nije pronađen',
    //SwitchSettings.jsx
    transcribe_to: 'Transkribujte',
    //ZoomForm.js
    integrate_zoom_to_start_meeting:
      'Integrišite zumiranje naloga da biste počeli sa zumiranjem sastanka.',
    zoom_is_not_integrated: 'Zumiranje nije integrisano',
    // Poll.jsx
    delete_poll: 'Izbrišite anketu',
    add_poll: 'Dodajte anketu',
    /* @Added By: Prabin */
    //Events
    live_now: 'UŽIVO SADA !!!',
    average_rating: 'Prosečna ocena',
    review: 'Recenzija',

    // Reports/Course/Details/Details.jsx
    time_spent: 'Utrošeno vreme',
    total: 'Ukupno',
    /* @Added By: Furkan */
    // Reports/Events/Preview/Preview.jsx
    mins: 'Minuta',
    /* @Added By: Furkan */
    // Reports/Lesson/Details/Internal/Quiz/Quiz.jsx
    no_data: 'Nema podataka za ovaj kviz',
    total_score: 'Ukupan rezultat',
    pass_score: 'Rezultat za prolaz',
    point: 'Poeni',
    /* @Added By: Furkan */
    // Reports/Lesson/Details/Internal/Quiz/QuizByUser/QuizByUser.jsx
    wrong: 'Pogrešno',
    response: 'Odgovor',
    submitted: 'Potvrđeno',
    /* @Added By: Furkan */
    // Reports/LiveAssessments/Preview/Preview.jsx
    average: 'Prosečno',
    /* @Added By: Furkan */
    // Reports/Maze/Preview/Preview.jsx
    total_play: 'Ukupna reprodukcija',
    view_graph: 'Prikaži grafikon',
    time_spent_mins: 'Utrošeno vreme (Minuti)',
    play: 'Pokreni',
    ideal_path: 'Idealna putanja',
    user_incorrect_path: 'Pogrešna putanja korisnika',
    ideal_path_taken: 'Idealna putanja koju je odabrao korisnik',
    scenario: 'Scenario',
    option: 'Opcija',
    spend: 'Potrošeno',
    /* @Added By: Furkan */
    // Reports/Report/Report.jsx
    average_spending_time: 'Prosečno potrošeno vreme',
    activity_overview: 'Pregled aktivnosti',
    /* @Added By: Furkan */
    // Reports/Report/Report_.jsx
    live_event: 'Događaji uživo',
    live_assessment: 'Procena uživo',
    report_download: 'Preuzimanje izveštaja',
    all_workshops: 'Sve radionice',
    /* @Added By: Furkan */
    // Reports/User/Detail/Detail.jsx
    overview_average_activity: 'Pregled prosečne aktivnosti',
    overview_workshop_graph: 'Pregled grafika radionice',
    correct_feedback: 'Ispravna povratna informacija',
    incorrect_feedback: 'Neispravna povratna informacija',
    checkin_checkout: 'Prijavljivanje - Odjavljivanje',
    minutes: 'minuti',
    incorrect_path: 'Pogrešna putanja',
    answer_not_available: 'Odgovor nije dostupan',
    views: 'prikazi',
    item: 'Artikal',
    questions: 'Pitanja',
    total_points: 'Ukupno poena',
    total_attempts: 'Ukupno pokušaja',
    /* @Added By: Furkan */
    // Reports/User/Detail/Detail.jsx
    created_date: 'Datum kreiranja',
    host_name: 'Ime domaćina',
    host_section: 'Odeljak “domaćin”',
    /* @Added By: Furkan */
    // views/SkillJourney/SkillJourney.jsx
    choose_products: 'Izaberite proizvode',
    scorms: 'Scorm-ovi',
    /* @Added By: Furkan */
    // views/SkillJourney/View/View.jsx
    skill_journey_overview: 'Pregled obilaska veština',
    /* @Added By: Furkan */
    // components/Header/internal/Informations/Informations.jsx
    how_to_use: 'Kako se koristi',
    live_broadcast_description:
      'INTEGRISALI SMO VIDEO UŽIVO U JEDNOSTAVAN GRADITELJ KURSEVA',
    live_broadcast_subdescription:
      'Sa ShareLook-ovim patentiranim sistemom prenosa uživo, možete stvoriti angažman, automatizovati učenje i maksimalno povećati  deljenje znanja.'
  },
  general: {
    save: 'sačuvajte',
    autosaved: 'Automatski sačuvano',
    back_to: 'Nazad na',
    by: 'Od',
    chat: 'Ćaskanje',
    is_record: 'Zapis', // to translate
    completed: 'Završeno',
    canceled: 'Otkazano',
    component: 'Komponenta',
    confirm: 'Potvrdite',
    course: 'Kursevi',
    date: 'Datum',
    details: 'Detalji',
    empty: 'Nema podataka',
    enrolled: 'Upisano',
    free: 'Besplatno',
    graph: 'Grafikon',
    loading: 'Učitavanje...',
    lesson: 'lekcija',
    lessons: 'lekcije',
    live_assessment: 'Procena uživo',
    live_event: 'Događaj uživo',
    maze: 'Lavirint', // to translate ,
    skill: 'Obilazak veština', // to translate
    no: 'Ne',
    of: 'Od',
    or: 'Ili',
    order: 'Poručite / Porudzbina', // to translate
    organization: 'Organizacija',
    page: 'Strana',
    pages: 'Strane',
    personal: 'Lično',
    poll: 'Anketa',
    rating: 'Ocena',
    reset: 'Poništite',
    signin: 'Prijavite se',
    signup: 'Prijavite se',
    soon: 'Uskoro',
    type: 'Tip',
    uploading: 'Otpremanje...',
    yes: 'Da',
    something_went_wrong: 'Nešto je pošlo naopako!',
    view_all: 'Prikaži sve',
    upload_successful: 'Otpremanje uspešno',
    upload_successful_message:
      'Excel dokumenti su uspešno otpremljeni i trenutno se obrađuju. Ovo može potrajati neko vreme.',
    check_email_upload_successful:
      'Molimo <0>proverite svoju e-poštu</0> za <1>izveštaj</1> otpremljene liste korisnika.',
    is_private: 'Privatno',
    to_attach: 'Priložite datoteku', // to translate
    file_attached: 'Priložena datoteka' // to translate
  },

  account: {
    title: 'Nalog',
    subtitle: 'Upravljajte postavkama i informacijama o nalogu.',
    saved: 'Nalog je uspešno promenjen'
  },

  assessments: {
    title: 'Procene',
    subtitle: 'Kreirajte procenu',
    finished: 'Procena je završena',
    countdown: 'Procena uživo će se emitovati u ',
    create: 'Kreirajte procenu',
    list_title: 'Vaše procene',
    delete_warning: 'Želite li zaista da izbrišete ovu stavku?',
    details_title: 'Dodajte detalje procene',
    details_subtitle:
      'Imenujte svoju Procenu i recite publici šta bi trebalo da očekuju da nauče iz nje.',
    disclaimer: `Garantujem da moja snimljena procena neće:
    - kršiti prava bilo kog trećeg lica
  - sadržati bilo kakvu nezakonitost, uključujući klevetnički, nepristojni, razvratni, pornografski, nasilni, uvredljivi, preteći ili diskriminatorni sadržaj, čak i prerušen zvezdicama
  - sadržati bilo kakve lične napade na druge ljude
  - sadržati bilo kakvo imitiranje drugih učesnika, javnih ličnosti ili poznatih ličnosti
  - sadržati bilo kakve snimke ili lične podatke o bilo kom pojedincu bez saglasnosti pojedinca i neće kršiti propise o zaštiti podataka ni u jednom delu sveta
  - sadržati bilo koji komercijalni zahtev ili bilo koji oblik bezvredne pošte`,

    // added_first
    assessment_details: 'Detalji procene', // to translate
    assessment_settings: 'Postavke procene' // to translate
  },

  buildersettings: {
    title: 'Postavke objavljivanja',
    subtitle:
      'Dodavanje postavki događaju, ko može da prikaže događaj i stupi u interakciju sa njim'
  },

  buttons: {
    market_place: 'Tržište',
    back_to_normal: 'Nazad u normalu',
    add: 'Dodati',
    add_page: 'Dodati stranicu',
    add_lesson: 'Dodati lekciju',
    add_answer: 'Dodati novi odgovor',
    add_group: 'Dodati grupu',
    add_organization: 'Dodati organizaciju',
    add_question: 'Dodati pitanje',
    add_quiz: 'Dodati kviz',
    add_users: 'Dodati korisnike',
    back: 'Nazad',
    back_to_maze: 'Nazad na pregled lavirinta', // to translate
    back_to_course: 'Nazad na pregled kursa',
    back_to_lesson: 'Nazad na pregled lekcija',
    back_to_media: 'Nazad na biblioteku medija',
    back_to_details: 'Nazad na detalje',
    cancel: 'Otkažite',
    clear: 'Obrišite',
    close: 'Zatvorite',
    clone: 'Klonirajte',
    close_lesson: 'Zatvorite lekciju',
    clone_course: 'Klonirajte kurs',
    confirm: 'Potvrdite',
    create: 'Kreirajte',
    download: 'Preuzimanje',
    download_mass_user_tamplate: 'Preuzmite šablon',
    add_mass_users: 'Dodajte masovne korisnike',
    upload_excel_list: 'Otpremanje Excel liste',
    delete: 'Izbrišite medije',
    edit: 'Uređivanje',
    edit_course: 'Uredite kurs',
    edit_maze: 'Uredite lavirint', // to translate
    enroll: 'Upišite',
    finish: 'Završite',
    wait: 'Sačekajte...', // to translate
    retry: 'Pokušajte ponovo', // to translate
    upload_image: 'Otpremanje slike',
    upload_image_video: 'Otpremanje slike ili video zapisa',
    select_media_library: 'Izbor iz biblioteke medija',
    make_public: 'Objavite javno',
    make_private: 'Napravite privatno',
    make_org: 'Napravite organizaciju',
    media: 'Biblioteka medija',
    my_theme: 'Moja tema',
    next: 'Sledeće',
    next_lesson: 'Sledeća lekcija',
    next_step: 'Sledeći korak',
    previous_step: 'Prethodni korak',
    publish: 'Objavite',
    publish_assessment: 'Objavite svoju procenu',
    publish_course: 'Objavite svoj kurs',
    publish_scorm_course: 'Objavite svoj SCORM kurs', // to translate
    publish_event: 'Objavite svoj događaj',
    publish_maze: 'Objavite svoj lavirint', // to translate
    reset: 'Poništite',
    reset_elements: 'Poništite elemente',
    save: 'Sačuvajte',
    creating: 'Kreiranje...',
    updating: 'Ažuriranje...',
    saved: 'Sačuvano',
    save_for_later: 'Sačuvajte za kasnije',
    save_settings: 'Sačuvajte postavke',
    select_files: 'Izaberite datoteke',
    select_theme: 'Izaberite temu',
    start_lesson: 'Počnite lekciju',
    update: 'Ažuriranje',
    import: 'Unesite elemente', // to translate
    upload: 'Otpremanje',
    upload_audio: 'Otpremanje zvuka',
    upload_photo: 'Otpremanje profilne fotografije',
    upload_video: 'Otpremanje Video zapisa',
    enrolled: 'Upisan',
    unenroll: 'Ispisan',
    from_library: 'Biblioteka medija',
    remove: 'Uklonite',
    removed: 'Uklonjeno',
    start_broadcast: 'Započnite emitovanje',
    end_broadcast: 'Završite emitovanje',
    camera: 'Kamera',
    screen: 'Ekran',
    screen_with_camera: 'Ekran sa kamerom',
    // added_first
    insert: 'Unesite', // to translate
    inserting: 'Unošenje', // to translate
    upload_pdf: 'Otpremanje PDF', // to translate
    portrait: 'Portret', // to translate
    landscape: 'Pejzaž', // to translate
    import_from_library: 'Unesite tekst iz biblioteke medija', // to translate
    question_answer_ai: 'Pitanje Odgovor Veštačka Inteligencija', // to translate
    //maze
    take_maze: 'UZMI LAVIRINT' // to translate
  },

  card: {
    quick_add: 'Brzo dodavanje',
    add: 'Dodati',
    clone: 'Klonirati',
    completed: 'Završene lekcije'
  },

  course: {
    upcoming_course: 'Predstojeći kurs',
    unPublishEvent: 'Opozovite objavljivanje događaja',
    unPublishAssessment: 'Opozovite objavljivanje procene',
    unPublishMaze: 'Opozovite objavljivanje lavirinta', // to translate
    pastCourse: 'Kurs obuke',
    upcoming: 'Predstojeći događaj uživo',
    upcomingMaze: 'Predstojeći lavirint', // to translate
    pastMaze: 'Prošli lavirint', // to translate
    pastEvent: 'Prpšli događaj uživo',
    pastAssessment: 'Prošla procena uživo',
    upcomingAssessment: 'Predstojeća procena uživo',
    created: 'Datum kreiranja:',
    assignees: 'Zastupnici',
    organisations:
      ' {{ organizacije }} Organizacije, <2> {{ korisnici }} korisnici</2>',
    event_date: 'Datum događaja uživo <1> {{ datum }} </1>',
    delete_warning: 'Da li ste sigurni da želite ovo da izbrišete',
    clonning_no_lesson:
      'Dodajte bar jednu lekciju da biste klonirali ovaj kurs.',
    clone_warning: 'Da li ste sigurni da želite ovo da klonirate',
    clone_success: 'Je u procesu kloniranja ',
    disclaimer: `Garantujem da moj kurs ne:
- krši prava bilo kog trećeg lica
- sadrži bilo kakvu nezakonitost, uključujući klevetnički, nepristojni, razvratni, pornografski, nasilni, uvredljivi, preteći ili diskriminatorni sadržaj, čak i prerušen zvezdicama
- sadrži bilo kakve lične napade na druge ljude
- sadrži bilo kakvo imitiranje drugih učesnika, javnih ličnosti ili poznatih ličnosti
- sadrži bilo kakve snimke ili lične podatke o bilo kom pojedincu bez saglasnosti pojedinca i neće kršiti propise o zaštiti podataka ni u jednom delu sveta
- sadrži bilo koji komercijalni zahtev ili bilo koji oblik "bezvredne pošte"`
  },

  coursecreate: {
    dropzone_text: 'Umetnite medije',
    sidebar_text: 'Izaberite temu <1/> za svoje <3/> lekcije',
    delete_warning: 'Da li ste sigurni da želite da izbrišete ovu lekciju?'
  },

  coursepage: {
    quizview_loading: 'Proveravam odgovore. Molim te sačekaj...',
    quizview_answer: 'Vaš odgovor'
  },

  coursequiz: {
    title: 'Kvizovi u svim lekcijama'
  },

  dashboard: {
    tooltip_title: 'Ne prikazuj ovaj video ponovo',
    page_title: 'Statistika Vaših kurseva',
    page_subtitle: 'Status kurseva koje ste kreirali',
    profile_add_info:
      'Dodajte <1>{{nedovršeniTekst}}</1> da biste dovršili profil.',
    profile_build:
      'Napravite svoj profil <1>ovde</1>, obavestite nas o svojim interesovanjima i veštinama.',
    profile_title: 'Jačina profila',
    more_details: 'Više detalja'
  },

  errors: {
    answer: 'Molimo unesite odgovor',
    answer_correct: 'Odaberite tačan odgovor',
    author: 'Molimo unesite ime autora', // to translate
    category: 'Molimo odaberite kategoriju', //to translate
    course_outline: 'Molimo unesite prikaz strukture kursa', // to translate
    course_obj: 'Molimo unesite ciljeve kursa', // to translate
    course_description: 'Molimo unesite opis kursa', // to translate
    maze_outline: 'Molimo unesite strukturu lavirinta', // to translate
    maze_obj: 'Molimo unesite ciljeve lavirinta', // to translate
    maze_description: 'Molimo unesite opis lavirinta', // to translate
    code: 'Molimo unesite kod',
    criterion: 'Molimo unesite kriterijum',
    duration: 'Trajanje je obavezno',
    element: 'Molimo unesite element',
    email: 'Molimo unesite e-poštu',
    email_invalid: 'Unesena e-pošta nije važeća',
    feedback_correct: 'Molimo ispravno unesite povratne informacije',
    feedback_incorrect: 'Molimo unesite neispravne povratne informacije',
    host: 'Molimo unesite domaćina događaja',
    host_assessment: 'Molimo unesite domaćina procene',
    image: 'Molimo otpremite sliku',
    lessons: 'Molimo unesite broj lekcija', // to translate
    location: 'Molimo unesite vašu lokaciju',
    live_location: 'Molimo odaberite lokaciju za emitovanje',
    limit: 'Molimo unesite minute za protok uživo',
    min_3char: 'Minimum 3 znaka',
    number: 'Unesite pozitivan broj.',
    host_email_require: `e-pošte domaćina su obavezne.`,
    attendee_email_require: `e-pošte učesnika su obavezne.`,
    user_email_require: `e-pošte korisnika su obavezne.`, // to translate
    team_size: `Veličina tima je obavezna.`, //to translate
    name: 'Unesite Vaše ime',
    not_found_course: 'Kurs nije pronađen',
    not_found_event: 'Događaj nije pronađen',
    not_found_assessment: ' Procena nije pronađena',
    organization: 'Molimo odaberite organizaciju', // to translate
    pass_score: 'Unesite oznake između 0 i 100', // to translate
    password: 'Molimo unesite lozinku',
    password_digit: 'Najmanje jedna cifra',
    password_short: 'Lozinka je prekratka, minimum 10 znakova',
    password_special: 'Najmanje jedan specijalni znak',
    password_uppercase: 'Najmanje jedano veliko slovo',
    password_lowercase: 'Najmanje jedano malo slovo',
    phone: 'Molimo unesite telefon',
    phone_invalid: 'Nevažeći telefonski broj',
    position: 'Molimo unesite položaj',
    price: 'Molimo unesite cenu (5 ili više)', // to translate
    question: 'Molimo unesite pitanje',
    start_date: 'Datum i vreme početka su obavezni',
    tag: 'Molimo izaberite oznaku',
    topics: 'Molimo izaberite najmanje jednu temu.',
    live_topics: 'Molimo dodajte teme',
    title: 'Molimo unesite naslov',
    title_assessment: 'Molimo unesite naslov procene',
    title_course: 'Molimo unesite naslov kursa',
    title_maze: 'Molimo unesite naslov lavirinta', // to translate
    title_empty: 'Naslov ne može biti prazan',
    title_event: 'Molimo unesite naslov događaja',
    title_lesson: 'Molimo unesite naslov lekcije',
    title_quiz: 'Molimo unesite naslov kviza',
    trainer_bio: 'Molimo unesite biografiju trenera', // to translate
    trainer_linkedin: 'Molimo unesite linkedin stranicu trenera', // to translate
    username: 'Molimo unesite korisničko ime',
    upload_error: 'Greška - datoteka nije kompatibilna!',
    upload_more_than_10: 'Možete da otpremite samo 10 datoteka odjednom.',
    video: 'Molimo unesite broj video zapisa', // to translate
    video_link: 'Molimo unesite link videa', // to translate
    topics_max: 'Dodajte najviše 5 tema.', // to translate  (just the digit 5)
    upload_excel: 'Uverite se da ste otpremili ispravnu datoteku.',
    title_excel: 'Greška pri otpremanju šablona:',
    file_size_exceed: 'Veličina datoteke premašuje',
    subtitle_excel:
      'Uverite se da ste koristili navedeni šablon i da li su kolone ispravno popunjene.',
    select_broadcast_option: 'Izaberite opciju emitovanja ovog događaja',
    multi_hosts_number_error:
      'Broj prezentatora ne može da premaši više od navedenog za događaj.',
    conference_people_number_error: `Broj učesnika ne može da premaši više od navedenog za događaj.`,
    select_max_host: 'Izaberite najmanje 1 prezentatora za događaj.',
    select_max_conference: 'Izaberite najmanje 1 učesnika za događaj.',
    stream_stop_error: 'Pokušavamo ponovno povezivnje…',
    no_stream_error: 'Čeka se domaćin da započne događaj',
    unsecure_context:
      'Fatalna greška: pretraživač ne može da pristupi kameri i mikrofonu zbog neobezbeđenog konteksta. Instalirajte SSL i pristupite putem https-a',
    ws_not_supported:
      'Fatalna greška: WebSocket nije podržan u ovom pretraživaču',

    // added_first
    no_org: 'Izaberite najmanje 1 organizaciju za nastavak.', // to translate
    no_org_group: 'Izaberite najmanje 1 organizacionu grupu za nastavak.', // to translate
    waiting_to_join: 'Čekamo da se neko priključi!', // to translate

    //new
    select_transcribe_locale: 'Izaberite jezik koji želite da transkribujete', // to translate
    transcribe_limit: 'Molimo unesite minute za transkripciju', // to translate
    not_complete: 'Informacije o tržištu nisu dovršene', // to translate
    complete: 'Informacije o tržištu su dovršene', // to translate
    not_admin:
      'Potrebna administratorska privilegija za objavljivanje na tržištu', // to translate
    no_course: 'Unesite naslov i izaberite sliku da biste omogućili tržište.', // to translate
    scorm_not_complete:
      'Unesite naslov i izaberite sliku za otpremanje skorm datoteke', // to translate
    //maze
    not_found_maze: 'Lavirint nije pronađen', // to translate
    email_require: 'E-pošte su obavezne', // to translate
    poll_required: 'Podaci ankete su obavezni.' // to translate
  },

  events: {
    title: 'Dodajte detalje događaja uživo',
    change_host: 'Promenite domaćina',
    finished: 'Događaj je završen',
    countdown: 'Događaj uživo će se emitovati u ',
    subtitle:
      'Imenujte svoj događaj uživo i recite publici šta bi trebalo da očekuju da nauče iz njega.',
    poll_disabled: 'Anketa nije dostupna u ovom događaju',
    disclaimer: `Garantujem da moj snimljeni događaj neće:
- kršiti prava bilo kog trećeg lica
- sadržati bilo kakvu nezakonitost, uključujući klevetnički, nepristojni, razvratni, pornografski, nasilni, uvredljivi, preteći ili diskriminatorni sadržaj, čak i prerušen zvezdicama
- sadržati bilo kakve lične napade na druge ljude
- sadržati bilo kakvo imitiranje drugih učesnika, javnih ličnosti ili poznatih ličnosti
- sadržati bilo kakve snimke ili lične podatke o bilo kom pojedincu bez saglasnosti pojedinca i neće kršiti propise o zaštiti podataka ni u jednom delu sveta
- sadržati bilo koji komercijalni zahtev ili bilo koji oblik "bezvredne pošte"`,
    prompt_message:
      'Napuštanje ove stranice će završiti vaš događaj. Želite li da napustite ovu stranicu?',
    duration_exceed_message:
      'Vaše vreme emitovanja premašuje, Aplikacija će prestati da emituje program.',
    before_schedule_message:
      'Samo što niste započeli emitovanje pre planiranog vremena događaja. Imajte u vidu da će se zaustavljanjem emitovanja završiti događaj.',
    browser_unsupportive_message:
      'Vaš pretraživač ne podržava deljenje ekrana. Podržane pretraživače možete videti na ovom linku',
    cancel_switch_host_message:
      'Domaćin nije dostupan. Događaj će biti nastavljen sa vašeg kraja.',
    coaching_prompt_message:
      'Ne možete napustiti ovu stranicu dok se događaj ne završi.',
    event_modal_warn: 'Želite li da napustite ovaj događaj?',
    event_end_warn: 'Želite li da završite ovaj događaj?',
    confirm_message: 'Događaj će se završiti ako kliknete na dugme "U redu".',
    screen_share_denied: 'Odbili ste da delite svoj ekran',
    media_not_found:
      'Kamera ili mikrofon nisu pronađeni ili nisu dozvoljeni na uređaju.',
    media_not_access:
      'Kamera ili Mikrofon koristi neki drugi proces koji ne dozvoljava čitanje uređaja',
    constraint_error:
      'Nije pronađen uređaj koji odgovara vašim video i audio ograničenjima. Možete da promenite ograničenja video zapisa i zvuka',
    media_access_denied: 'Nije vam dozvoljeno da pristupite kameri i mikrofonu.'
  },

  filters: {
    days7: 'Poslednjih 7 dana',
    days15: 'Poslednjih 15 dana',
    days30: 'Poslednjih 30 dana',
    days365: 'Poslednjih 365 dana',
    date: 'Datum kreiranja',
    relevance: 'Važnost',
    popularity: 'Popularnost',
    name: 'Ime',
    group: 'Grupa',
    Newest_to_Oldest: 'Od novijeg do starijeg',
    Oldest_to_Newest: 'Od starijeg do novijeg',
    A_Z: 'Od A do Š',
    Z_A: 'Od Š do A'
  },

  helpers: {
    password:
      'Da bismo osigurali bezbednost vašeg naloga, potrebno nam je najmanje jedno malo slovo, broj u vašoj lozinki. Takođe je potrebno da imate minimalnu dužinu od 10 znakova.',
    phone: 'Unesite i pozivni broj zemlje, na primer: +65',
    username:
      'Vaše korisničko ime se po potrebi tretira kao javno informisanje i deli sa drugim korisnicima. Kao takvi, preporučujemo da ne koristite lične informacije u korisničkom imenu',
    public_description_normal:
      ' Vaš <0><0/></0> je sačuvan i podrazumevano se smatra privatnim. To znači da samo vi možete da vidite ovaj sadržaj. Da biste objavili ovaj sadržaj, možete izabrati jednu od dole navedenih opcija. Objavljivanje <0><0/></0> za Javnost znači da će biti dostupan svim korisnicima u platformi. Opcija "Određeni korisnici" će vam omogućiti da delite svoj <0><0/></0> sa određenim korisnicima koristeći e-adresu povezanu sa njihovim Sharelook nalogom.',
    public_description_admin:
      'Ovaj <0><0/></0> je sačuvan i podrazumevano se smatra privatnim. To znači da samo vi (i kreator sadržaja) možete da vidite ovaj sadržaj . Da biste objavili ovaj sadržaj, možete izabrati jednu od dole navedenih opcija. Objavljivanje <0><0/></0> za javnost znači da će biti dostupan svim korisnicima u platformi - uključujući i one van vaše organizacije. Objavljivanje u organizaciji znači da će svi korisnici unutar organizacije moći da je vide. Takođe možete da je objavite u 1 ili više grupa, što znači da će samo korisnici unutar tih grupa moći da je vide. Na kraju, imate mogućnost da je objavite određenim korisnicima unutar i izvan vaše organizacije koristeći e-adresu sharelook naloga.'
  },

  labels: {
    add: 'Dodajte',
    no_of_people_in_conference: 'Koliko je ljudi na konferenciji?', //to translate
    portrait: 'Obsecite portret',
    landscape: 'Obsecite pejzaž',
    transcribe_settings: 'Postavke transkribovanja', // to translate
    transcribe: 'Transkribujte', // to translate
    answer_type: 'Tip odgovora',
    answers: 'Odgovori',
    back_to_quiz: 'Back to Quiz list',
    back_to_question: 'Nazad na spisak pitanja',
    chat: 'Ćaskanje',
    chat_available: 'Ćaskanje nije dostupno u ovom događaju',
    chat_report: 'Izveštaj ćaskanja',
    choice_single: 'Jedan izbor',
    choice_multiple: 'Više izbora',
    choice_free: '"Slobodan" izbor',
    choice_sorting: '"Sortiranje" - izbor',
    choice_matrix: '"Matriks Sortiranje" - izbor',
    clone_lesson_permission: 'Dozvola kloniranja',
    code: 'Kod',
    correct: 'Ispravno',
    created: 'Datum kreiranja',
    clone_modal: 'Klonirajte kurs',
    cloning_course: 'Kloniranje kursa...',
    cloning_maze: 'Kloniranje lavirinta...', //to translate
    cloning: 'Kloniranje...',
    cloning_course_desc:
      'Ovaj proces će malo potrajati. Molimo Vas budite strpljivi.',
    cloning_success: 'Kurs "<0/>" je uspešno kloniran!',
    maze_cloning_success: 'Lavirint "<0/>" je uspešno kloniran!', // to translate
    create_certificate: 'Kreirajte sertifikat', // to translate
    create_badge: 'Kreirajte bedz', // to translate
    certificate_added: 'Sertifikat je dodat.', // to translate
    badge_added: 'Bedz je dodat.', // to translate
    certificate_warning:
      'Ne možete da uređujete certifikat/značku kada se objavi!', // to translate
    description: 'Opis',
    disclaimer: 'Odricanje odgovornosti',
    drop_file: 'Spustite datoteku ovde...',
    duration: 'Trajanje',
    edit: 'Uređivanje',
    email: 'E-pošta',
    event: 'Događaj',
    event_all: 'Svi njegovi događaji',
    event_date: 'Lokalni datum/vreme događaja uživo',
    event_this: 'Ovaj događaj',
    expire: 'Ističe',
    expiry_date: 'Rok trajanja',
    forgot: 'Zaboravili ste lozinku?',
    group: 'Grupa',
    groups_list: 'Spisak grupa',
    host: 'Domaćin',
    id_annotation: 'ID napomene',
    id_number: 'ID broj', // to translate
    id_quiz: 'ID kviza',
    incorrect: 'Neispravno',
    interests: 'Interesi',
    invited: 'Pozvani',
    live_chat: 'Diskusija uživo',
    live_stream_limit: 'Minuti protoka uživo',
    contact_text:
      'Da biste promenili mesečno ograničenje protoka uživo, kontaktirajte',
    contact_admin:
      '<0> Ako želite da promenite mesečno ograničenje protoka uživo, molimo vas da kontaktirate </0> <1>admin@sharelook.com</1>',
    limit_stream_text:
      'Preostali minuti uživo: <0>{{ limit }}</0> minuta <1/><2/> <3>Da biste promenili mesečno ograničenje protoka uživo molimo vas da kontaktirate</3> <4>admin@sharelook.com</4>',
    location: 'Lokacija',
    lessons: 'Lekcije',
    location_broadcast: 'Lokacija servera domaćina',
    location_broadcast_subtitle:
      'Dodavanje lokacije koja je najbliža lokaciji domaćina emitovanja da bi se smanjilo audiovizuelno kašnjenje',
    media_manager: 'Menadžer media',
    minutes: 'Minuti',
    name: 'Ime',
    online_quiz: 'Online kviz',
    organiser: 'Autor',
    organization: 'Organizacija',
    overall_emotion: 'Sveukupno iskustvo:',
    organizations_list: 'Spisak organizacija',
    password: 'Lozinka',
    participants: 'Učesnici',
    pass_score: 'Najmanji broj poena za prolaz', // to translate
    picture: 'Slika',
    scorm_zip: 'Scorm Zip', // to translate
    phone: 'Telefon',
    photo: 'Fotografija',
    poll: 'Anketa',
    position: 'Položaj',
    processing: 'Obrada',
    privacy_settings: 'Postavke privatnosti',
    question: 'Pitanje',
    quiz_create: 'Kreirajte kviz',
    quiz_name: 'Naziv kviza',
    quiz_update: 'Ažurirajte kviz',
    select_organization: 'Izbor organizacije',
    settings: 'Postavke',
    show: 'Prikaži',
    show_graph: 'Prikaži rezultat grafikona',
    signin: 'Prijavi se',
    signup: 'Prijavi se',
    sort_by: 'Sortiraj po',
    start_date: 'Datum početka',
    tags: 'Oznake',
    terms: 'Pristajem na ove <1>uslove</1>.',
    timezone: 'Vremenska zona', //to translate
    title: 'Naslov',
    topics: 'Teme',
    topic: 'Tema',
    total_comments: 'Ukupni komentari',
    username: 'Korisničko ime',
    users_list: 'Spisak korisnika',
    users_emails: `Odaberite e-poštu određenog korisnika`,
    description_specifiction_email:
      'Unesite 1 e-adresu po redu da biste ovo podelili sa više određenih korisnika.',
    message_specific_email: 'Unesite e-poruku određenog korisnika.',
    viewers: 'Gledaoci',
    edit_course: 'Uređivanje',
    edit_assessment: 'Uređivanje',
    edit_event: 'Uređivanje',
    edit_maze: 'Uređivanje', //to translate
    delete_course: 'Izbrišite',
    delete_event: 'Izbrišite',
    delete_maze: 'Izbrišite', //to translate
    delete_assessment: 'Izbrišite',
    view_course: 'Prikaz',
    view_event: 'Prikaz',
    view_assessment: 'Prikaz',
    view_maze: 'Prikaz', //to translate
    date_event: 'Datum događaja uživo',
    date_assessment: 'Datum procene uživo',
    clone_of: 'Klon',
    clone_course:
      'Napravite klona ovog kursa koji možete modifikovati nezavisno od originala, uključuje sve lekcije i stranice.',
    make: 'Napraviti',
    available_to: 'dostupno bilo kom ShareLook korisniku',
    uploaded_by: 'Otpremljeno od strane: ',
    course: 'Kurs',
    assessment: 'Procena',
    user_not_exist: 'Korisnik ne postoji, želite li da pošaljete pozivnicu?',
    check_user: 'Primetiti',
    user_not_exist_in_org:
      'Korisnik ne postoji u ovoj organizaciji, želite li da pošaljete pozivnicu?',
    title_modal_stream: 'Promenite ograničenje emitovanja za organizacije',
    des_warning_stream: 'Uskoro će te promeniti',
    monthly_stream: 'mesečno ograničenje emitovanja uživo:',
    min_per_month: 'minuti/meseci',
    broadcast_label: 'Želim da uradim:',
    hosts_emails: `Unesite e-poštu određenog domaćina`,
    attendee_emails: `Unesite e-poštu određenog učesnika`,
    examinee_emails: `Unesite e-poštu određenog ispitanika`, // to translate
    description_host_specifiction_email: 'Unesite 1 e-poštu po redu.',
    presenter_label: 'Prezentator',
    presenter_label_conference: 'Broj ljudi',
    event_privacy: 'Režim konferencije',
    // added_second
    alert: 'Uzbuna!', // to translate
    warning: 'Upozorenje!', // to translate
    ok: 'U redu', // to translate
    cancel: 'Otkažite', // to translate
    done: 'Gotovo', // to translate
    insert: 'Umetnite', // to translate
    private: 'Privatno', // to translate
    public: 'Javno', // to translate
    no_connection: 'Internet veza je izgubljena', // to translate
    switch: 'Prebacite', // to translate
    share_screen: 'Deljenje ekrana', // to translate
    stop_share_screen: 'Zaustavite deljenje ekrana', // to translate
    share_screen_with_camera: 'Deljenje ekrana sa kamerom', // to translate
    stop_share_screen_with_camera: 'Zaustavi deljenje ekrana sa kamerom', // to translate
    camera_on: 'Kamera uključena', // to translate
    camera_off: 'Kamera isključena', // to translate
    mic_on: 'sa zvukom', // to translate
    mic_off: 'bez zvuka', // to translate
    fullscreen: 'ceo ekran', // to translate
    live_now: 'Uživo Sada', // to translate
    schedule_on: 'Zakažite za', // to translate
    organisations: 'Organizacioje', // to translate
    org_groups: 'Organizacione Grupe', // to translate
    specific_user: 'Određeni korisnik', // to translate
    gif: 'GIF', // to translate
    unavailable: 'nedostupno', // to translate
    yes: 'Da', // to translate
    no: 'Ne', // to translate
    event_duration_message: 'Maksimum 300 minuta(5h)', // to translate
    send_email: 'Pošaljite obaveštenje e-poštom', // to translate
    admin_only: 'Samo admin', // to translate
    join: 'Pridruži se', // to translate
    leave: 'Napusti', // to translate
    share: 'Podeli', // to translate
    share_text: 'Upišite e-poštu sa kim želite da odelite ovu datoteku', // to translate
    share_text_title: 'Podelite PDF', // to translate
    share_text_title_txt: 'Podelite Tekst', // to translate
    select_users: 'Odaberite korisnike', // to translate
    delete: 'Obrišite', // to translate
    attachment_event: 'Prilozi za događaj: ', // to translate,
    // newly added
    transcribe_limit: 'Transkribuj miute', // to translate
    monthly_transcribe: 'ograničenje mesečne transkribopcije:', // to translate
    enable_ai: 'Omogući Veštačku Inteligenciju:', // to translate
    media_service: 'Medijska usluga', // to translate
    allow_others: 'Dozvoli drugima da uređuju' // to translate
  },

  broadcastOptions: {
    stream_from_phone: 'Direktan prenos pomoću telefona',
    other_webrtc: 'Webinar sa računara',
    multihost: 'Multicast webinar sa računara',
    peer2peer: 'Trenerska sesija',
    conference: 'Konferencija uživo'
  },

  //to translate
  conferenceTeamOptions: {
    uptoTen: '1 do 10', // to translate
    uptoTwenty: '11 do 20', // to translate
    uptoTwentyFive: '21 do 25' // to translate
    // uptoForty: '31 do 40'
  },

  //to translate
  conferenceAttendeeOptions: {
    uptoTwoHundredFifty: '1 do 250' // to translate
    // uptoHundred: '51 do 100',
    // uptoTwoHundred: '101 do 200'
    // uptoForty: '31 do 40'
  },

  mediaServices: {
    ANTMEDIA: 'ANTMEDIA', // to translate
    CHIME: 'CHIME' // to translate
  },

  lessoncreate: {
    title: 'Dodajte detalje lekcije',
    subtitle:
      'Imenujte svoju lekciju i recite publici šta bi trebalo da očekuju da nauče iz nje.',
    input_label_title: 'Naslov lekcije',
    input_label_topics: 'Tema lekcije',
    input_label_description: 'Opis lekcije',
    delete_warning: 'Želite li zaista da izbrišete ovu stranicu?'
  },

  lessonoverview: {
    title: 'Dodajte lekciju',
    subtitle: 'Dodajte postojeću lekciju ili kreirajte novu',
    new_lesson: 'kreirajte novu lekciju',
    new_lesson_sub: 'Kreirajte potpuno novu lekciju od nule!',
    existing_lesson: 'Izaberite postojeću lekciju',
    existing_lesson_sub:
      'Link ka postojećoj lekciji, promene napravljene u ovoj lekciji uticaće i na ovu lekciju na drugim kursevima.',
    clone_lesson: 'duplirajte postojeću lekciju',
    clone_lesson_sub:
      'Napravite jedinstvenu kopiju lekcije na ovom kursu, promene napravljene u ovoj lekciji neće uticati na originalnu lekciju.',
    clone_lesson_modal_sub:
      'Kliknite na dugme klon ispod lekcije koju želite da dodate svom kursu.'
  },

  management: {
    groups_title: 'Upravljanje grupama',
    delete_warning: 'Da li ste sigurni?',
    organizations_title: 'Moje organizacije',
    organizations_subtitle: 'Dodajte organizaciju na listu',
    users_title: 'Upravljanje korisnicima',
    users_position: 'Viši menadžer naloga',
    user_not_found: 'Korisnik nije pronađen',
    select_org:
      'Pronađite i odaberite organizaciju koja će upravljati korisnicima',
    select_org_report:
      'Pronađite i odaberite organizaciju za generisanje izveštaja' // to translate
  },

  audio: {
    modal_title: 'Unesite zvuk',
    list_view: 'Prikaz liste',
    create_audio_modal_title: 'Kreirajte zvuk',
    edit_audio_modal_title: 'Uređivanje zvuka',
    public_audio_not_found: 'Zvuk nije pronađen.',
    private_audio_not_found: 'Još uvek niste otpremili nikakav zvuk',
    org_audio_not_found: 'Zvuk nije pronađen.', // to translate
    are_you_sure_to_delete: 'Da li stvarno želite da izbrišete?',
    type_something: 'Otkucaj nešto',
    select_voice: 'Izaberite',
    file_name: 'Naziv datoteke',
    description: 'Opis',
    topic: 'Tema',
    key_words_tag: 'Ključne reči Oznaka',
    mp3_audio: 'MP3 zvuk',
    created: 'Kreirano',
    duration: 'Trajanje',
    close: 'zatvorite'
  },

  image: {
    modal_title: 'Umetnite sliku',
    image: 'Slika',
    pixel: 'Piksel',
    dimension: 'Dimenzija',
    public_image_not_found: 'Slika nije pronađena.',
    private_image_not_found: 'Još uvek niste otpremili sliku',
    org_image_not_found: 'Slika nije pronađena.' // to translate
  },

  annotation: {
    modal_title: 'Napomena'
  },

  text: {
    modal_title: 'Uređivač teksta',
    insert_text: 'Unesite tekst', // to translate
    insert_question_answer: 'Pitanje Odgovor Veštačka Inteligencija', //to translate
    modal_title2: 'Tekstualna galerija', // to translate
    my_text_library: 'Moja biblioteka teksta', // to translate
    ai: 'Veštačka Inteligencija', // to translate
    public_text_library: 'Javna biblioteka', // to translate
    organization_text_library: 'Biblioteka Organizacije', // to translate
    no_transcribed_text: 'Nema transkribovanih tekstova', // to translate
    public_text_not_found: 'Javni transkribovani tekst nije pronađen.', // to translate
    org_text_not_found: 'Transkribovan tekst organizacije nije pronađen.' // to translate
  },

  video: {
    modal_title: 'Umetnite video',
    image: 'Video',
    mp4_video: 'MP4 Video',
    public_video_not_found: 'Video nije pronađen.',
    private_video_not_found: 'Još niste otpremili nijedan video',
    org_video_not_found: 'Video nije pronađen.' // to translate
  },

  media: {
    title: 'Biblioteka medija',
    subtitle: 'Biblioteka datoteka',
    modal_title: 'Otpremanje medija',
    canva: 'Uradi to iz Canve', // to translate
    canva_open: 'Kliknite ovde da biste otvorili alatku "Canva Editor"', //to translate
    delete_warning: 'Potvrda brisanja',
    delete_message:
      'Izbrisani mediji će se i dalje pojavljivati na stranicama na kojima su korišćeni',
    dropzone_text: 'ili prevuci i otpusti',
    delete_success: 'Medij je uspešno izbrisan',
    upload_file: 'Otpremite datoteku',
    drag_drop: 'ili prevuci i otpusti',
    import_file: 'Unesite datoteku/e sa računara',
    no_media: 'Još uvek niste otpremili nijedan medij',
    media_type: 'Tip medija',
    video: 'Video',
    image: 'Slika',
    audio: 'Audio',
    gif: 'GIF',
    pdf: 'PDF', // to translate
    transcribed_text: 'Transkribovan tekst',
    txt: 'TEKST', // to translate
    media_not_found: 'Medij nije pronađen.',
    of: 'od',
    disclaimer: `Garantujem da moj medij neće:
- kršiti prava bilo kog trećeg lica
- sadržati bilo kakvu nezakonitost, uključujući klevetnički, nepristojni, razvratni, pornografski, nasilni, uvredljivi, preteći ili diskriminatorni sadržaj, čak i prerušen zvezdicama
- sadržati bilo kakve lične napade na druge ljude
- sadržati bilo kakvo imitiranje drugih učesnika, javnih ličnosti ili poznatih ličnosti
- sadržati bilo kakve snimke ili lične podatke o bilo kom pojedincu bez saglasnosti pojedinca i neće kršiti propise o zaštiti podataka ni u jednom delu sveta
- sadržati bilo koji komercijalni zahtev ili bilo koji oblik "bezvredne pošte”`,

    // added_first
    my_media: 'Moj medij', // to translate
    maze_scenes: 'Scene lavirinta', // to translate
    public_library: 'Javna biblioteka', // to translate
    organization_library: 'Biblioteka Organizacije', // to translate
    upload_from_computer: 'Otpremite sa računara', // to translate
    pexel_images: 'Peksel slika', // to translate
    create: 'Kreirajte', // to translate
    all: 'Sve', // to translate
    male: 'Muškarac', // to translate
    female: 'Žena', // to translate
    processing_audio: 'Obrada zvuka', // to translate
    create_annotation: 'Kreirajte napomenu', // to translate
    popup_over_lesson_text:
      'Napomena će iskočiti preko stranice sa lekcijama nakon klika', // to translate
    edit_detail: 'Uredi detalje', // to translate
    delete: 'Izbrišite', // to translate
    go_create_audio: 'Idi kreiraj zvuk', // to translate
    show_more_details: 'prikaži više detalja', // to translate
    show_less_details: 'prikaži manje detalja', // to translate
    drop_files: 'Otpustite datoteke, gde da ih otpremite', // to translate
    or: 'Ili', // to translate
    import_files: 'Unesite datoteke sa računara', // to translate
    // added_fourth
    human: 'Premium', // to translate
    shared_file: 'Vaša datoteka je uspešno podeljena', // to translate
    error_shared_file: 'Postoji problem u deljenju datoteke, pokušajte ponovo', // to translate
    publish: 'Objavite' // to translate
  },

  navigation: {
    account: 'Nalog',
    assessments: 'Procene',
    dashboard: 'Kontrolna tabla',
    groups: 'Upravljanje grupama',
    logout: 'Odjavite se',
    organisations: 'Organizacije',
    organizations_users: 'Organizacije i Korisnici',
    reports: 'Izveštaji',
    schedule: 'Raspored',
    training: 'Trening',
    users: 'Korisnici',

    // added_first
    nowLive: 'Uživo',

    workshop: 'Moja radionica'
  },

  onboarding: {
    step1_title: 'Korak 1: Recite nam nešto o sebi',
    step1_subtitle: 'Kako se zovete? Odakle ste? Koje je Vaše radno mesto?',
    step2_title:
      'Korak 2: Izaberite neku veštinu koju biste mogli da usavršite',
    step2_subtitle:
      'Dalje nam recite šta biste voleli da razumete bolje. Možda nešto što još ne znate? Novo polje studiranja? Šta vaša voljena osoba radi?'
  },

  pagebuilder: {
    title: 'Kreirajte lekciju',
    subtitle:
      'Vreme je da kreirate sadržaj koji će gledaoci učiti od vas, možete da unesete slikate, video zapise i infografiku',
    select_layout: 'Izbor rasporeda na stranici',
    template1: 'Prazno',
    template2: 'Naslov i Titl',
    template3: 'Naslov i Tekst',
    template4: 'Naslov, Mediji i Tekst',
    template5: 'Naslov i Mediji',
    template6: 'Naslov i Kviz'
  },

  pageconstructor: {
    title: 'Kreiraj i kloniraj lekciju',
    subtitle:
      'Vreme je da kreirate sadržaj koji će gledaoci učiti od vas, možete da dodate slike, video zapise i infografiku'
  },

  passwordreset: {
    success_coded:
      'Poslali smo Vam na e-poštu kod za potvrdu, molimo vas da kopirate kod u polje ispod da biste postavili novu lozinku.',
    success_changed:
      'Uspešno ste postavili novu lozinku. Sada možete da se prijavite.'
  },

  placeholders: {
    attempts_count: 'Broj pokušaja, korisnik može ponovo da pokuša', // to translate
    no_of_people_placeholder: 'Broj ljudi', //to translate
    search: 'Pretraga',
    answer: 'Odgovor',
    chat: 'Recite nešto...',
    code: 'Kod',
    criterion: 'Kriterijum',
    date_event: 'Izaberite datum i vreme',
    date_start: 'Datum početka',
    date_expire: 'Datum isteka',
    description: 'Opis',
    elements: 'Sortiranje elemenata',
    email: 'E-pošta',
    feedback_correct: 'Ispravne povratne informacije',
    feedback_incorrect: 'Neispravne povratne informacije',
    host: 'Domaćin',
    keywords: 'Pretražite ključne reči',
    lesson_description: 'Opis lekcije',
    location: 'Lokacija',
    minutes: 'Minuti',
    name: 'Ime',
    organiser: 'Autor',
    organization: 'Organizacija',
    password: 'Lozinka',
    phone: 'Telefon',
    photo: 'Fotografija',
    picture: 'Slika',
    point: 'Poeni',
    position: 'Položaj',
    question: 'Pitanje',
    quiz: 'Naziv kviza',
    search_course: 'Pretražite po kursu',
    search_media: 'Pretražite medij',
    search_name: 'Pretražite po imenu',
    search_title: 'Pretražite po naslovu',
    search_training: 'Pretražite obuke',
    settings: 'Postavke',
    tags: 'Oznake',
    title: 'Naslov',
    topics: 'Teme',
    username: 'Korisničko ime',
    keyword: 'Ključne reči',
    max_500_characters: 'Najviše 500 znakova',
    no_description: 'Ova datoteka nema opis',
    no_keyword: 'Ova datoteka nema ključne reči',
    no_topics: 'Ova datoteka nema skup tema',
    feedback: 'Poruka',
    contact: 'Kako možemo da pomognemo?',
    text: 'Unesite tekst ovde...' //to translate
  },

  publishsettings: {
    title: 'Postavke objavljivanja',
    event_subtitle:
      'Dodavanje postavki događaju, ko može da gleda događaj i stupi u interakciju sa njim',
    assessment_subtitile:
      'Imenujte svoju Procenu i recite publici šta treba da očekuju da nauče iz nje',
    course_subtitle:
      'Dodavajte postavke kursu, ko može da gleda kurs i stupi u interakciju sa njim',
    disclaimer:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis',
    dates_validation_error: 'Oba datuma bi trebalo da budu popunjena.',
    emails_validation_error: 'Lista e-pošte je nevažeća.',
    specific_email_validation_error: 'Dozvoljena je samo jedna e-pošta.',
    i_agree_to_these: 'Slažem se sa ovim ',
    terms_and_conditions: 'uslovima i odredbama.',
    PublicDescription:
      'Besplatni nezavisni korisnici: (privatne i javne opcije)Vaš [Kurs| Događaj| Procena] je sačuvan i podrazumevano se smatra privatnim. To znači da samo vi možete da vidite ovaj sadržaj. Da biste objavili ovaj sadržaj, možete da izaberete da bude javno objavljen ispod. To znači da će kurs biti dostupan svim korisnicima u platformi.',
    OrganisationsDescription:
      'Korisnici organizacije: (Umesto "Završi", koristite "Objavi" i postavite ih na stranicu za objavljivanje isto kao i drugi korisnici, ali bez ikakvih opcija objavljivanja.) Tvoj [Kurs| Događaj| Procena] je sačuvan i privatan je. To znači da samo vi i administratori u vašoj organizaciji to možete da vidite. Kao korisnik, ne možete sami da objavite sadržaj unutar svoje organizacije jer to zahteva administratorska prava. Obratite se jednom od administratora i zamolite ih da objave vaš sadržaj javno, celoj organizaciji, određenim grupama unutar vaše organizacije ili određenim korisnicima.',
    OrganisationGroupsDescription:
      'Admini organizacije: (Za sadržaj napravljen u okviru organizacije: privatni, javni, organizacioni, grupni, određeni korisnici):Ovaj [Kurs| Događaj| Procena] je sačuvan i podrazumevano se smatra privatnoim. To znači da samo vi (i kreator sadržaja) možete da vidite ovaj sadržaj . Da biste objavili ovaj sadržaj, možete izabrati jednu od dole navedenih opcija. Objavljivanje kursa za javnost znači da će biti dostupan svim korisnicima u platformi - uključujući i one van vaše organizacije. Objavljivanje u organizaciji znači da će svi korisnici unutar organizacije moći da je vide. Takođe možete da  objavite u 1 ili više grupa, što znači da će samo korisnici unutar tih grupa moći da vide. Na kraju, imate mogućnost da objavite određenim korisnicima unutar i izvan vaše organizacije koristeći e-adresu sharelook naloga..',
    SpecificUsersDescription:
      'Plaćeni nezavisni korisnici: (privatni, javni i specifični korisnici)Vaš [Kurs| Događaj| Procena] je sačuvan i podrazumevano se smatra privatnim. To znači da samo vi možete da vidite ovaj sadržaj. Da biste objavili ovaj sadržaj, možete izabrati jednu od dole navedenih opcija. Objavljivanje kursa za javnost znači da će biti dostupan svim korisnicima u platformi. Opcija "Određeni korisnici" će vam omogućiti da delite kurs sa određenim korisnicima koristeći e-adresu povezanu sa njihovim Sharelook nalogom.'
  },

  quiz: {
    quiz_empty: 'Još uvek niste napravili kviz',
    questions_empty: 'Još uvek niste kreirali pitanje'
  },

  regions: {
    asia_pacific_australia: 'Australija',
    asia_pacific_india: 'Indija',
    asia_pacific_japan: 'Japan',
    asia_pacific_s_korea: 'Južna Koreja',
    asia_pacific_singapore: 'Singapur',
    asia_pacific_taiwan: 'Tajvan',
    eu_belgium: 'Belgija',
    eu_germany: 'Nemačka',
    eu_ireland: 'Irska',
    south_america_brazil: 'Brazil',
    us_central_iowa: 'Ajova',
    us_east_s_carolina: 'Južna Karolina',
    us_east_virginia: 'Virdžinija',
    us_west_california: 'Kalifornija',
    us_west_oregon: 'Oregon'
  },

  publishmaze: {
    title: 'Postavke objavljivanja', // to translate
    maze_subtitle:
      'Dodajte podešavanja u svoj lavirint, ko može da vidi i komunicira sa vašim lavirintom', // to translate
    disclaimer: `Garantujem da moj lavirint neće:
- kršiti prava bilo kog trećeg lica
- sadržati bilo kakvu nezakonitost, uključujući klevetnički, nepristojni, razvratni, pornografski, nasilni, uvredljivi, preteći ili diskriminatorni sadržaj, čak i prerušen zvezdicama
- sadržati bilo kakve lične napade na druge ljude
- sadržati bilo kakvo imitiranje drugih učesnika, javnih ličnosti ili poznatih ličnosti
- sadržati bilo kakve snimke ili lične podatke o bilo kom pojedincu bez saglasnosti pojedinca i neće kršiti propise o zaštiti podataka ni u jednom delu sveta
- sadržati bilo koji komercijalni zahtev ili bilo koji oblik "bezvredne pošte"` // to translate
  },

  reports: {
    title: 'Izveštaji',

    // added_first
    workshop_report: 'Izveštaj radionice',
    user_report: 'Izveštaj korisnika',
    organization_workshop: 'Radionica Organizacije',
    course: 'Kurs',
    live_event: 'Događaj uživo',
    workShop_graph: 'Grafikon radionice',
    organization_account: 'Nalog Organizacije',
    all: 'Sve',
    name: 'Ime',
    group: 'Grupa', //to translate
    group_name: 'Ime grupe', //to translate
    select_group: 'Izaberite grupu', //to translate
    id_number: 'ID Broj',
    email: 'E-pošta',
    search_user_report: 'Pretraži korisnički izveštaj',
    participant: 'Učesnik',
    participants: 'Učesnici',
    host: 'Domaćin',
    hosts: 'Domaćini', //to translate
    username: 'Korisničko ime',
    event: 'Događaj',
    quiz: 'Kviz',
    assessment: 'Procena',
    time: 'Vreme',
    no_recent_activity: 'Nema nedavnih aktivnosti',
    workshops: 'Radionice',
    courses: 'Kursevi',
    live_events: 'Događaji uživo',
    live_assessments: 'Procene uživo',
    quizzes: 'Kvizovi',
    overview: 'Pregled',
    by: 'Od',
    views: 'Pregledi',
    status: 'Status',
    pass_score: 'Rezultat za prolaz', // to translate
    poll: 'Anketa',
    comment: 'Komentar',
    comments: 'Komentari',
    no_comments: 'Nema komentara',
    no_polls: 'Nema Anketa',
    live_date: 'Datum lajva',
    score: 'Rezultat',
    question: 'Pitanje',
    submit: 'Podnesite',
    recent_activity: 'Nedavna aktivnost',
    ago: 'Pre',
    no_data_found: 'Nisu pronađeni podaci',
    start_end_live: 'Pokreni / Završi lajv',
    join_leave_date: 'Pridruži se / Napusti',
    watched_time: 'Vreme gledanja',
    complete: 'Kompletan',
    in_complete: 'Nekompletan',
    today: 'Danas',
    seven_days: '7 Dana',
    last_month: 'Prošlog meseca',
    one_year: '1 godina',
    all_time: 'Sve vreme',
    report: 'Izveštaj',
    from_date: 'Od datuma',
    to_date: 'Do datuma',
    all_workshop: 'Sve radionice',
    all_participants: 'Svi učesnici',
    live_assessment: 'Procena uživo',
    users: 'Korisnici',
    download: 'Preuzimanje',
    recent: 'Nedavno',
    WorkShop: 'Radionica',
    Activity: 'Aktivnost',
    created_date: 'Datum kreiranja',
    lessons: 'Lekcije',
    lesson: 'Lekcija',
    completed: 'Dovršeno',
    report_download: 'PREUZIMANJE',
    this_month: 'Ovog meseca',
    search_course: 'Pretraži kurs',
    // search_skill_journey: "Search Skill journey", // to translate
    search_maze: 'Pretraži lavirint', // to translate
    participants_graph: 'Grafikon učesnika',
    viewed: 'Pregledano',
    enrolled: 'Upisano',
    description: 'Opis',
    topic: 'Tema',
    analytic: 'Analitika',
    quiz_list: 'Spisak kvizova',
    select_one: 'Izaberite jedan',
    group_status: 'Status grupe',
    duration_min: 'Trajanje (min)',
    submit_poll: 'Prosledite anketu',
    download_events: 'Preuzmite događaje',
    search_event: 'Pretražite događaje',
    duration: 'Trajanje',
    total_participants: 'Ukupno učesnika',
    message: 'Poruka',
    avg_message: 'Pros. poruka',
    per_message: 'PROCENAT PORUKA / DOGAĐAJ',
    avg_score: 'Prosečan rezultat', // to translate
    maze: 'Lavirint', // to translate
    maze_report: 'Izveštaj o lavirintu', // to translate
    maze_view: 'Pregled lavirinta', // to translate
    title_maze: 'Lavirint', // to translate
    author: 'Autor', // to translate
    match: 'Podudaranje putanje', // to translate
    preview_mazeTitle: 'Naslov: ', // to translate
    other: 'Ostalo', // to translate
    total: 'UKUPNO', // to translate
    report_courses: 'KURSEVI', // to translate
    report_events: 'DOGAĐAJI', // to translate
    report_maze: 'LAVIRINT', // to translate
    report_personalize_learning: 'PERSONALIZOVANJE UČENJA', // to translate
    report_live_assessments: 'PROCENE UŽIVO', // to translate
    report_skill_journey: 'OBILAZAK VEŠTINA', // to translate
    skill_journey: 'Obilazak veština', // to translate
    skill_journeys: 'Obilazak veština', // to translate
    date: 'DATUM: ', // to translate
    search_people: 'Pretražite osobe', // to translate
    passed: 'POLOŽENO', // to translate
    failed: 'NIJE USPEŠNO', // to translate
    item: 'ARTIKAL', // to translate
    items: 'ARTIKLI', //to translate
    type: 'TIP', // to translate
    minimum_pass_score: 'MINIMALNI REZULTAT ZA PROLAZ', // to translate
    resources_count: 'BROJ RESURSA', // to translate
    back: 'NAZAD', // to translate
    resources: 'RESURSI', // to translate
    time_spent: 'UTROŠENO VREME (MIN)', // to translate
    detail: 'DETALJ', // to translate
    watched_time_mins: 'GLEDANO VREME (MIN)', // to translate
    personalize_learning: 'personalizovanje učenja', // to translate
    result: 'rezultat', // to translate
    assessment_title: 'Naslov' // to translate
  },

  signup: {
    success_step1:
      'Poslali smo verifikacioni kod na adresu koju ste uneli, molimo vas da kopirate kod u polje ispod da biste potvrdili vašu registraciju.',
    success_step2: 'Hvala. Uspešno ste registrovani.',
    privacy:
      'Slažem se sa Sharelook-ovim <1> dredbama i uslovima</1> i <3> pravilima privatnosti</3>'
  },

  stream: {
    emotion_impressive: 'Impresivno',
    emotion_unimpressive: 'Neimpresivno',
    message_not_started: 'Uskoro',
    message_running: 'Uživo',
    message_processing:
      'Trenutno obrađujemo snimak uživo za reprodukciju. Proverite kasnije da biste videli video zapis i nastavili da dodajete ocene i povratne informacije'
  },

  tabs: {
    audience: 'Publika',
    course: 'Pregled kursa',
    details: 'Detalji događaja uživo',
    description: 'Opis',
    host: 'Domaćin',
    lesson: 'Pregled lekcije',
    lessons: 'Lekcije',
    overview: 'Pregled',
    page: 'Izrada stranica',
    publish: 'Objavite',
    settings: 'Postavke objavljivanja',
    total_views: 'Ukupno pregleda',
    live_participates: 'Učesnici lajva',
    live_chats: 'Ćaskanje uživo',
    live_quiz: 'Ankete uživo',
    trainer_rating: 'Ocena trenera',
    trainer_times: 'Vreme trenera',
    courses_quizzes: 'Kvizovi kurseva',
    user_list: 'Spisak korisnika',
    discussion: 'Diskusija',
    notes: 'Moje beleške',
    attachments: 'Dodatni prilog' // to translate
  },

  topics: {
    SALES_TRAINING: 'Obuka o prodaji',
    NEGOTIATION_TRAINING: 'Obuka za pregovore',
    CROSS_CULTURAL_AWARENESS: 'Međukulturna svest',
    NETWORKING_SKILLS: 'Veštine umrežavanja',
    SOFTWARE_ARCHITECTURE: 'Izgradnja softvera',
    PROJECT_MANAGEMENT: 'Projektni Menadžment',
    DIGITAL_TRANSFORMATION: 'Digitalna transformacija',
    IT_CONSULTING: 'IT Konsalting',
    MANAGEMENT_CONSULTING: 'Menadžment Konsalting',
    HR_CONSULTING: 'HR Konsalting',
    INTERNET_OF_THINGS: 'Internet stvari (IoT)',
    CYBERSECURITY: 'Sajber bezbednost',
    PRIVACY_AND_GDRP: 'Privatnost i GDPR'
  },

  training: {
    title: 'Trening',
    title_assessment: 'Procene',
    subtitle: 'Kursevi i događaji uživo',
    enrolled_title: 'Upisani kursevi i događaji uživo',
    enrolled_subtitle: 'Kursevi i događaji uživo koje ste upisali',
    enrolled_message: 'Trenutno niste upisani ni na jedan kurs i događaj.',
    maze_channel: 'Moj Lavirint kanal', // to translate
    past_live_assessment: 'Prethodne procene uživo', // to translate
    no_live_assessment: 'Trenutno nema procena uživo', // to translate
    past_live_event_title: 'Prethodni događaji uživo',
    past_live_event_subTitle: 'Završeni događaji uživo',
    past_live_event: 'Trenutno nema prethodnih događaja uživo.',
    recomended_title: 'Preporučeni kursevi i događaji uživo',
    now_live_event_title: 'Sada uživo',
    now_live_event_subTitle: 'Događaji koji su uživo ili će biti vrlo brzo',
    now_live_event: 'Trenutno nema događaja uživo.',
    no_maze: 'Trenutno nema lavirinata.', // to translate
    webinar_event_title: 'Vebinar kanal',
    webinar_event_subTitle: 'Završeni Vebinari',
    webinar_event: 'Trenutno nema vebinara.',
    p2p_event_title: 'Trenerske sesije',
    p2p_event_subTitle: 'Završena trenerska sesija',
    p2p_event: 'Trenutno nema trenerskih sesija.',
    // new translate
    conference_event_title: 'Konferencije', // to translate
    conference_event_subTitle: 'Završene konferencije', // to translate
    conference_event: 'Trenutno nema konferencija.', // to translate
    skill_journey: 'Obilazak veština', // to translate
    no_skill: 'Trenutno nema obilaska veština.', // to translate

    now_live_assessment_title: 'Uživo sada',
    now_live_assessment_subTitle: 'Procena koja je uživo ili će biti vrlo brzo',
    now_live_assessment_message: 'Trenutno ne postoji procena uživo.',

    upcoming_assessment_title: 'Predstojeće procene uživo',
    upcoming_assessment_subtitle: 'Predstojeće procene uživo',
    upcoming_assessment_message:
      'Trenutno ne postoji predstojeća procena uživo',

    past_live_assessment_title: 'Prethodne procene uživo',
    past_live_assessment_subTitle: 'Završene procene uživo',
    past_live_assessment_message: 'Trenutno nema prethodnih procena uživo.',

    /**
     * <0/> get index 0 of data from Trans component
     * exp -->
     * <Trans i18nKey='training:recomended_subtitle' >
     *    <Navlink>{...something}</Navlink> --> is index 0 of Trans component
     *    <h1>{...something}</h1> --> is index 1 of Trans component
     * </Trans>
     */
    recomended_subtitle:
      'Kurseve i događaje uživo smo pripremili na osnovu vaših <0><0/></0>',
    /**
     * and we also can get data from index to replace in recommended_subtitle by like above string.
     * for exp -->
     * at the end of the recomended_subtitle above will get data from index of component to display
     * <0><0/></0> mean get data index 0 of Trans component above = <Navlink> and <0/> get data index 0 from <Navlink> = {...something}
     */
    search: 'Pretražite obuke',
    search_assessment: ' Pretražite procene',
    recomended_message: 'Trenutno nema preporučenih kurseva i događaja.',
    search_user: 'Pretpažite ime kompanije' // to translate
  },

  warnings: {
    delete: 'Da li ste sigurni?'
  },

  workshop: {
    title: 'Moja radionica',
    subtitle: 'Kreirajte kurs ili hostujte sopstveni događaj uživo',
    new_course: 'Kreirajte novi kurs',
    new_scorm_course: 'Otpremite novi SCORM kurs', // to translate
    upload_scorm_course: 'Otpremite SCORM kurs', // to translate
    new_event: 'Kreirajte novi događaj uživo',
    new_maze: 'Kreirajte novi lavirint', // to translate
    new_skill_journey: 'Kreirajte obilazak veština', // to translate
    new_assessment: 'Kreirajte nove procene uživo',
    courses_title: 'Kreirajte Kurseve i Događaje uživo',
    courses_subtitle: 'Edit & Publish your created course and plan live events',
    tags_course: 'Kurs',
    tags_scorm: 'SCORM', // to translate
    tags_live: 'Događaj uživo',
    tags_assessment: 'Procena uživo',
    tags_skillJourney: 'Obilazak veština' // to translate
  },

  help_center: {
    sidebar: {
      title: 'Kako možemo da vam pomognemo?',
      back_to: 'Kontrolna tabla'
    },
    menu: {
      help_center: 'Centar za pomoć',
      whats_new: 'Šta je novo',
      feedback: 'Povratne informacije',
      feedback_title: 'Pošaljite povratne informacije sharelook-u',
      terms_and_conditions: 'Odredbe & Uslovi',
      privacy_policy: 'Politika privatnosti',
      contact_us: 'Kontaktirajte nas'
    },
    get_started: {
      title: 'Zpočnite sa ShareLook-om',
      new_title: 'Korisnički vodič', // to translate
      description: {
        main: 'INTEGRISALI SMO VIDEO UŽIVO U JEDNOSTAVAN GRADITELJ KURSEVA',
        tagline:
          'Pomoću ShareLook-ovog patentiranog sistema emitovanja uživo možete da kreirate angažman, automatizujete učenje i maksimalno povećate deljenje znanja.'
      }
    },
    whats_new: {
      title: 'Zpočnite sa ShareLook-om',
      description: {
        main:
          'Da li ste znali da kreiranje storytelling stila učenja može da se stvori za kratko vreme i ne tako skupo? Trebalo bi da kombinujete ShareLook graditelja kurseva i talente. Možete nas pitati "KAKO”',
        tagline: 'slogan'
      }
    },
    create_workshop: 'Kako napraviti radionicu?',
    create_course: 'Kako napraviti kurs?',
    create_user: 'Kako napraviti korisnika?',
    create_group: 'Kako napraviti grupu?',
    create_webinar: 'Kako napraviti Vebinar?',
    create_live_event: 'Kako napraviti događaj uživo?',
    create_live_assessment: 'Kako napraviti procenu uživo?',
    create_live_on_mobile: 'Kreirajte uživo na mobilnom',
    personalize_profile: 'Personalizovanje profila',
    manage_group: 'Upravljanje grupom',
    report: 'Izveštaj',
    add_annotations: 'Kako dodati napomene/iskačuće prozore',
    add_audio: 'Kako dodati zvuk?',
    add_header_and_footer: 'Dodavanje zaglavlja i podnožja',
    add_image: 'Kako dodati sliku?',
    add_quiz_content: 'Kako dodati sadržaj kviza?',
    add_text_content: 'Kako dodati tekstualni sadržaj?',
    add_user: 'Kako dodati korisnika?',
    add_video: 'Kako dodati video?',
    clone_course: 'Kako klonirati kurs?',
    find_live_broadcast: 'Kako pronaći prenos uživo?',
    transcribe_and_translate_live_broadcast: 'Prevedi/transkribuj uživo prenos', // to translate
    transcribe_and_translate_your_live_broadcast:
      'Kako da transkribujete i prevedete prenos uživo', // to translate
    contact_us: {
      title: 'Kontaktirajte nas',
      subject_placeholder: 'Unesite temu*',
      content_placeholder: 'Unesite poruku*',
      subject_required: '*Tema je obavezna',
      content_required: '*Poruka je obavezna',
      submit: 'Pošalji',
      cancel: 'Otkaži',
      sent: 'Poslato'
    },
    feedback: {
      title: 'Pošalji povratne informacije sharelook-u',
      attach_title: 'Priložite datoteku',
      choose: 'Odaberite datoteku',
      detail: 'Datoteka će biti podeljena sa timom za podršku',
      content_placeholder: 'Unesite poruku*',
      content_required: '*Poruka je obavezna',
      submit: 'Pošalji',
      cancel: 'Otkaži',
      sent: 'Poslato'
    }
  },
  discussion: {
    join_discussion: 'Pridružite se diskusiji'
  },
  notes: {
    title: 'Moje beleške',
    add_note: 'Dodajte novu belešku'
  },
  // added_third
  groups: {
    search_group: 'Pretraži organizacionu grupu' // to translate
  },
  /* Information object is to be translated */
  v4: {
    title: 'Šta želiš da radiš danas?', // to translate
    build_course: 'Napravi moj kurs', // to translate
    live_broadcast: 'Prenos uživo', // to translate
    invite_users: 'Pozovi korisnike u moju organizaciju', // to translate
    build_voice_over: 'Napravi moj snimak glasa', // to translate
    view_reports: 'Prikaz izveštaja', // to translate
    upload_media: ' Otpremite moj medij ili posao i delite ga', // to translate
    main_menu: 'Glavni Meni', // to translate
    get_started: 'POČNITE' // to translate
  }
  /* To Translate  */
}
